export class FontFamily {
	fontValue: string;
	fontLabel: string;

	constructor(options: { fontValue?: string; fontLabel?: string }) {
		this.fontValue = options.fontValue || '';
		this.fontLabel = options.fontLabel || '';
	}
}
